import React, { useEffect, useState } from 'react';
import propTypes from 'prop-types';
import { StyledCheckboxes } from '../../../../Components/Generics.styled';
import styled from 'styled-components';
import { StyledButton } from '../../../../Components/Generics.styled';

const WhoAreYourCustomersContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

const NavButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Btn = styled(StyledButton)`
    width: 100%;
    max-width: 360px;
    border: 1px solid white;
`;

const WhoAreYourCustomers = ({
    handleNavButtonBack,
    handleNavButtonNext,
    teachDavieData,
    setTeachDavieData,
}) => {
    const { whoAreCustomers } = { ...teachDavieData };

    const [value, setValue] = useState({
        consumers: false,
        businesses: false,
        institutions: false,
        governments: false,
    });

    const options = [
        {
            checked: value.consumers,
            onChange: () => {
                setValue({ ...value, consumers: !value.consumers });
            },
            label: 'Consumers',
        },
        {
            checked: value.businesses,
            onChange: () => {
                setValue({ ...value, businesses: !value.businesses });
            },
            label: 'Businesses',
        },
        {
            checked: value.institutions,
            onChange: () => {
                setValue({ ...value, institutions: !value.institutions });
            },
            label: 'Institutions',
        },
        {
            checked: value.governments,
            onChange: () => {
                setValue({ ...value, governments: !value.governments });
            },
            label: 'Governments',
        },
    ];

    useEffect(() => {
        if (whoAreCustomers) {
            setValue(whoAreCustomers);
        }
    }, [whoAreCustomers]);

    const handleNext = () => {
        setTeachDavieData((prev) => ({ ...prev, whoAreCustomers: value }));
        handleNavButtonNext();
    };
    return (
        <WhoAreYourCustomersContainer>
            <StyledCheckboxes label={'Who are your customers?'} options={options} />
            <br />
            <NavButtonContainer>
                <Btn onClick={() => handleNavButtonBack()}>Previous</Btn>
                <Btn onClick={() => handleNext()}>Next</Btn>
            </NavButtonContainer>
        </WhoAreYourCustomersContainer>
    );
};

WhoAreYourCustomers.propTypes = {
    handleNavButtonBack: propTypes.func,
    handleNavButtonNext: propTypes.func,
    teachDavieData: propTypes.shape({}),
    setTeachDavieData: propTypes.func,
};

WhoAreYourCustomers.defaultProps = {
    handleNavButtonBack: () => {},
    handleNavButtonNext: () => {},
    teachDavieData: {},
    setTeachDavieData: () => {},
};

export default WhoAreYourCustomers;
